<template>
    <div class="sidebar">
        <div class="sidebar__head">
            <div class="sidebar__head--title">
                <router-link :to="'/driving_school'">TABLEAU DE BORD</router-link>
            </div>
        </div>
        <div class="sidebar__body">
            <div class="sidebar__body__menu-name">Nouvelle attestation</div>
            <ul class="sidebar__body__menu mb-3">
                <li class="sidebar__body__menu--item" v-for="item in garantieItems">
                    <router-link class="link-with-bg" :class="{'active-tab' : activeTab === item.key}" :to="item.url">{{item.name}}</router-link>
                </li>
            </ul>
            <div class="sidebar__body__menu-name">Informations</div>
            <ul class="sidebar__body__menu mb-3">
                <li class="sidebar__body__menu--item">
                    <router-link class="link-with-bg" to="/double_commande/mon-compte">Mon compte</router-link>
                </li>
                <li class="sidebar__body__menu--item">
                    <a href="#" class="link-logout link-with-bg" @click="$root.logOut">Deconnexion</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {DRIVING_SCHOOOL_CONST} from "@/driving_school_consts";

    export default {
        name: 'DrivingSchoolSidebar',
        data() {
            return {
                garantieItems: [
                    {name: 'Examen permis de conduire', url: '/double_commande/double_commande_attestation', key: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.DRIVING_LICENCE.KEY},
                    {name: 'Examen VTC', url: '/double_commande/vtc_attestation', key: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.VTC.KEY},
                    {name: 'Examen BEPECASER', url: '/double_commande/bepecaser_attestation', key: DRIVING_SCHOOOL_CONST.ATTESTATION_TYPE.BEPECASER.KEY},
                ],
                activeTab: ''
            }
        },
        methods: {
            setActiveTab(tabName) {
                console.log('tabName',tabName);
                this.activeTab = tabName;
            }
        },
        mounted() {
            this.$eventBus.$on('driving-school-sidebar-set-active-tab', this.setActiveTab);
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/DrivingSchool/DrivingSchoolSidebar.vue